import { simulateCallbacksForFilledForm } from '../../binders/daq/utils';
import { Dao } from '../../dao';
import { Gizmo } from '../../gizmos';
import { rootGizmoDataV2ToV3 } from '../../gizmos/utils';
import {
  IFormGizmoV2,
  IGizmoCallbacks,
  IGizmoData,
  IGizmoQuestionV2,
  IRealmFilledForm,
} from '../../types';
import Flux from '../flux';

interface IAnnexFormValuesParams {
  variable: string;
  context: {
    gizmoCallbacks: IGizmoCallbacks;
    // synchronizer?: Synchronizer;
    dao?: Dao;
    gizmo?: Gizmo;
    answerGizmo?: Gizmo;
  };
}

/**
 * Get data from an annex form gizmo
 *
 * @param {string} variable variable from where
 * @returns
 */
function annexFormValues({
  variable,
  context,
}: IAnnexFormValuesParams): Promise<IGizmoData[] | undefined> {
  return new Promise<IGizmoData[] | undefined>(async resolve => {
    const { dao, answerGizmo, gizmoCallbacks, gizmo } = context;

    console.log('aaaaaaaaaaaaaaaaaaaaaaaannexFormValues->variable: ', variable, ', context: ', context);
    if (dao && answerGizmo) {
      // Right now we're supporting accessing gizmos via uid
      const [uid, gizmoUid] = variable.split('.');
      const fid = gizmoCallbacks.getInfoCB({
        type: 'uidToFid',
        uid,
      });
      const data: IGizmoData[] = gizmoCallbacks.getInfoCB({
        type: 'data',
        fid,
      });
      console.log('annexFormValues->data: ', data, ', variable: ', variable, ', uid: ', uid, ', gizmoUid: ', gizmoUid);
      const rootGizmoFid = gizmoCallbacks.getInfoCB({
        type: 'rootGizmoFid',
      });
      const config = answerGizmo.getConfig();

      if (
        config.ops?.annexForm?.rootGizmoFid &&
        data &&
        rootGizmoFid &&
        Array.isArray(data) &&
        data.length > 0
      ) {
        let question: IGizmoQuestionV2 | undefined;
        let childForm: IFormGizmoV2 | undefined;
        const filter: string | undefined = gizmo?.getConfig().ops?.value
          ?.filter;

        try {
          // const rgc = await dao.getRootGizmoConfigs({
          //   fid: data[0].afd?.formId!,
          // });
          // console.log('<><><><> rgc: ', rgc);
          const childRealmForm = await dao.getDatabase()?.get({
            type: 'forms',
            fid: data[0].afd?.formId!,
          });
          childForm = childRealmForm?.formGizmo;
          question = childForm?.questions.find(
            (q: IGizmoQuestionV2) => q.uid === gizmoUid
          );
          console.log('<><><><>chF: ', childForm, ', q: ', question);
        } catch (e) {
          console.log('++++++++++++++++++++annexFormValues->e: ', e);
        }

        const gizmoData: IGizmoData[] = [];
        for (const d of data) {
          let includeInList = true;
          try {
            if (d.afd?.filledFormId && question) {
              const childFilledForm: IRealmFilledForm = await dao
                .getDatabase()
                ?.get({
                  type: 'filledForms',
                  fid: d.afd?.filledFormId,
                });

              console.log('annexFormValues->childFilledForm: ', childFilledForm, ', question: ', question, ', childForm: ', childForm, ', filter: ', filter);

              if (filter && childFilledForm && childForm) {
                const callbacks = simulateCallbacksForFilledForm({
                  form: childForm,
                  filledForm: rootGizmoDataV2ToV3({
                    data: childFilledForm.gizmoData,
                  }),
                });
                const flux: Flux = new Flux({
                  gizmoCallbacks: callbacks,
                  dao: undefined,
                  gizmo: undefined,
                });
                await flux.init();

                const result = await flux.evaluate({
                  script: filter,
                });

                if (typeof result === 'boolean') {
                  includeInList = result;
                }
              }

              if (includeInList) {
                const chidlRootGizmoData = rootGizmoDataV2ToV3({
                  data: childFilledForm.gizmoData,
                });

                if (chidlRootGizmoData.d) {
                  const childData = chidlRootGizmoData.d[question.f_id];
                  if (childData && !Array.isArray(childData)) {
                    gizmoData.push(childData);
                  }
                }
              }
            }
          } catch (e) {
            console.log('eeeeeee: ', e);
          }
        }

        console.log('ggggggggggggggggggggggggD: ', gizmoData);
        return resolve(gizmoData);
      }
    }

    // if (synchronizer && answerGizmo) {
    //   // Right now we're supporting accessing gizmos via uid
    //   const [uid, gizmoUid] = variable.split('.');
    //   const fid = gizmoCallbacks.getInfoCB({
    //     type: 'uidToFid',
    //     uid,
    //   });
    //   const data = gizmoCallbacks.getInfoCB({
    //     type: 'data',
    //     fid,
    //   });
    //   const rootGizmoFid = gizmoCallbacks.getInfoCB({
    //     type: 'rootGizmoFid',
    //   });
    //   const config = answerGizmo.getConfig();
    //   if (config.options?.annexForm?.rootGizmoFid && data && rootGizmoFid) {
    //     const index = await synchronizer.getEmbeddedFilledFormsIndex({
    //       formId: rootGizmoFid,
    //       parentGizmoFid: fid,
    //       parentAnswers: data,
    //       includeFilledForms: true,
    //     });

    //     const { form, filledForms } = index;
    //     if (form && filledForms) {
    //       const g = form.questions.find(q => q.uid === gizmoUid);
    //       const filter: string | undefined = gizmo?.getConfig().options?.value
    //         ?.filter;

    //       if (g) {
    //         const gizmoData: IGizmoData[] = [];

    //         for (const filledForm of filledForms) {
    //           let includeInList = true;

    //           // If a filter is configured we're going to evaluate it with flux
    //           if (filter) {
    //             const callbacks = simulateCallbacksForFilledForm({
    //               form,
    //               filledForm,
    //             });
    //             const flux: Flux = new Flux({
    //               gizmoCallbacks: callbacks,
    //             });
    //             await flux.init();
    //             const result = await flux.evaluate({
    //               script: filter,
    //             });
    //             if (typeof result === 'boolean') {
    //               includeInList = result;
    //             }
    //           }

    //           if (includeInList) {
    //             gizmoData.push(filledForm.answers[g.f_id]);
    //           }
    //         }

    //         return resolve(gizmoData);
    //       }
    //     }
    //   }
    // }

    resolve(undefined);
  });
}

export default annexFormValues;
